import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-number-input'

import 'react-phone-number-input/style.css'
import { useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
import { useNavigate, useParams } from 'react-router-dom';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import eventBus from '../common/EventBus';
import { Logger } from 'sass';

const CustomUpdate = (props) => {
    console.log("CustomUpdate props",props)
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [userInfo, setUserInfo] = useState();


    const [userType, setUserType] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
  const [hasBluetick, setHasBluetick] = useState(false);


    useEffect(() => {
        onLoadData();

    }, []);


    const onLoadData = () => {

        AccountService.inquireUser().then(
            (response) => {
                console.log("loadUserInfo", response)

                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFollowed", response?.data?.data?.dataList)
                    let _info = response?.data?.data?.dataList[0];
                    setUserInfo(_info);
                    setFirstName(_info.firstName);
                    setLastName(_info.lastName);
                    setEmail(_info.email);
                    setUserName(_info.userName);
                    setPhoneNumber(_info.phoneNumber);
                    setUserType(_info.userType);
                    setHasBluetick(_info.hasBluetick==1?true:false);

                    console.log("_info.hasBluetick",_info.hasBluetick)
                }
            },
            (error) => {
                console.log("inquireUser error*", error)

                //  setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireUser logout******")
                    eventBus.dispatch("logout", props);
                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }


  




    const passwordInfo = () => {

        return (

            <div className="col-12 md:col-12 flex justify-content-center w-full" >
                <div className="register-content  w-12   p-3">
                    <div className="col-12 md:col-12" style={{
                        wordWrap: 'break-word',
                        paddingBottom: 5,
                    }}>
                        {t('update_descr2')}
                    </div>
                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">

                            <div className="col-12 md:col-6  p-3">
                                <InputText type="password" placeholder={t("global_text_password")}
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    required
                                    className="inputtext_raunded p-inputtext "
                                />

                            </div>
                            <div className="col-12 md:col-6  p-3">
                                <InputText type="password" placeholder={t("global_text_confirmpassword")}
                                    onChange={(e) => setPasswordConfirm(e.target.value)}
                                    value={passwordConfirm}
                                    required
                                    className="inputtext_raunded p-inputtext "
                                />
                            </div>
                            <div className="col-12 md:col-12  p-3">
                                <PasswordChecklist
                                    rules={["minLength", "specialChar", "number", "capital", "match"]}
                                    minLength={5}
                                    value={password}
                                    valueAgain={passwordConfirm}
                                    onChange={(isValid) => { }}
                                    messages={{
                                        minLength: t('validation_password_minlength'),
                                        specialChar: t('validation_password_specialchar'),
                                        number: t('validation_password_number'),
                                        capital: t('validation_password_capital'),
                                        match: t('validation_password_match')
                                    }}
                                />
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>

        )

    }




    const checkButtonStatus = () => {

        let _status = false;

        if (password && passwordConfirm) {
            _status = true;

        } else if (phoneNumber && phoneNumber.length > 5) {
            _status = true;
        }
        else {
            _status = false;
        }

        console.log("checkButtonStatus return last", _status);
        return !_status;

    }




    const onUpdate = () => {

        console.log(phoneNumber, password, passwordConfirm)
        


        console.log("onUpdate");
        if ( phoneNumber?.length > 5 ||( password?.length > 0 && passwordConfirm?.length > 0)) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                id:userInfo?.id,
                
            };

            if(phoneNumber?.length > 5){
                apiParams.phoneNumber = phoneNumber;
            }
            if(password?.length>0){
                apiParams.password = password;
                apiParams.passwordConfirm = passwordConfirm;
            }

            console.log("onUpdate", apiParams);

            let _userList=[];
            _userList.push(apiParams);

            let _updateRequest={users:_userList}

            AccountService.updateUsers(_updateRequest).then(

                (response) => {

                    console.log("onUpdate", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }

                       //TODO props.toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onUpdate", response);

                        setDisplayLoadingDialog(false);
                        props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });


                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                      //TODO  props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("verification_error_descr2"), life: 5000 });

        }


    }



    const authInfo = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  " >
                <div className="register-content w-12   p-3">
                    <div className="col-12 md:col-12 font-bold" style={{
                        wordWrap: 'break-word',
                        paddingBottom: 5,
                    }}>
                        {t('update_descr1')}
                    </div>
                    <div className="col-12 md:col-12">
                        <div className="col-12 md:col-12 grid font-normal" style={{
                            wordWrap: 'break-word',
                            paddingBottom: 5,
                        }}>
                            <div className='flex justify-content-center text-700 text-l font-bold pr-3'>
                                {firstName+" "+lastName} 

                                {hasBluetick == 1 &&
                                    <div
                                        className="blue-check-point ml-1 mt-1" style={{ height: 12, width: 12 }}  >
                                        <i className="fas fa-check" style={{ fontSize: '8px' }} ></i>


                                    </div>
                                }
                            </div>

                            <div className='pl-2 pr-2' style={{ borderLeft: '2px solid #dee2e6' }}>
                                @{userName}

                            </div>
                            <div className='pl-2 pr-2' style={{ borderLeft: '2px solid #dee2e6' }}>

                                {t('global_text_' + userType)}
                            </div>
                        </div>


                    </div>
                    <div className="col-12 md:col-12 grid">
                        <div className="col-12 lg:col-6  mb-2">
                            <InputText id="email" value={AuthService.getUserMail()} autoComplete="off"
                                disabled={true}
                                className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_text_email')}></InputText>
                        </div>
                        <div className="col-12 lg:col-6  mb-2">
                            <PhoneInput
                                international
                                placeholder="Enter phone number"
                                defaultCountry="TR"
                                value={phoneNumber}
                                onChange={(phone) => { console.log(phone); setPhoneNumber(phone) }}
                                className="inputtext_raunded p-inputtext "
                            />
                        </div>




                    </div>

                </div>
            </div>
        )

    }




    const renderButton = () => {

        return (
            <div className=" flex justify-content-center p-1 w-12">
                <div className=" w-fit ">
                    <Button label={t("global_btn_update")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                        onClick={() => onUpdate()}

                    />
                </div>

            </div>
        )
    }
    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {authInfo()}
            {passwordInfo()}

            {renderButton()}


        </div>
    )
}

export default CustomUpdate;